import { useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useAuthState } from './AuthContext';

// Decodes the signed-in user's email from the JWT. The token is validated
// server-side, so decode failures here are non-fatal and just yield ''.
export function useTokenEmail(): string {
    const auth = useAuthState();
    const [email, setEmail] = useState('');

    useEffect(() => {
        if (!auth.token) return;
        try {
            const decoded = jwtDecode<{ email?: string }>(auth.token);
            if (decoded?.email) setEmail(decoded.email);
        } catch {
            /* token is validated server-side; ignore decode errors here */
        }
    }, [auth.token]);

    return email;
}
